import React from 'react';
import { CtaButton } from './CtaButton';
import { volumes } from '../data/content';
export function Volumes() {
  return <section className="w-full bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-247" data-mp="1lw1z651zcuru">
      <div className="mx-auto max-w-4xl" data-id="element-248" data-mp="184ezrwcqr64u">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.2em] text-brand-600" data-id="element-249" data-mp="185ga1ylxnoli">
          📚 Contenuto del kit
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] font-extrabold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-250" data-mp="1zvb428kqk2gi">
          Cosa contiene il Kit Clinico per la Gestione dell’Obesità?
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[15px] font-medium leading-relaxed text-inksoft sm:text-lg" data-id="element-251" data-mp="1qv676sd64mgl">
          Un Percorso Clinico completo che ti accompagna dalla valutazione iniziale fino al follow-up
          a lungo termine.
        </p>

        <ol className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-252" data-mp="fhkg31nr0asf">
          {volumes.map(vol => <li key={vol.number} className="flex h-full flex-col rounded-3xl border border-brand-100 bg-cream p-5 sm:p-6" data-id="element-253" data-mp="kby76rvdnvra">
              <div className="flex items-center gap-3" data-id="element-254" data-mp="3jadffgvasu79">
                <span className="text-2xl leading-none" aria-hidden="true" data-id="element-255" data-mp="20oxo52yucfu">
                  {vol.emoji}
                </span>
                <span className="rounded-full bg-brand-500 px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-256" data-mp="3t6834qedpfgw">
                  {vol.number}
                </span>
              </div>
              <h3 className="mt-4 font-display text-[19px] font-bold leading-snug text-ink sm:text-xl" data-id="element-257" data-mp="61sb6kxjjwdw">
                {vol.title}
              </h3>
              <p className="mt-3 text-[14px] font-medium leading-relaxed text-inksoft sm:text-[15px]" data-id="element-258" data-mp="fsd9s8d7t0wt">
                {vol.text}
              </p>
            </li>)}
        </ol>

        <div className="mt-10" data-id="element-259" data-mp="tps3hpai3uul">
          <CtaButton label="Voglio i 6 volumi ora" note="Accesso immediato in PDF · Computer, tablet e smartphone" data-id="element-260" data-mp="prc5kqcvt22e" />
        </div>
      </div>
    </section>;
}